import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=5cc82816&"
import script from "./ToggleSwitch.vue?vue&type=script&lang=ts&"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports